import Vue from "vue";
import axios from "axios";
import enviroment from "@/assets/js/enviroment";

Vue.prototype.$http = axios;

// API principal da QuiteJá
const apiCore = axios.create({ baseURL: enviroment.apiUrl });

const setToken = (token) => {
  apiCore.defaults.headers["authentication-token"] = token;
};

apiCore.interceptors.response.use(
  (r) => { return r; },
  (error) => {
    if ([401, 403].includes(error?.response?.status)) {
      window.location = enviroment.authAppUrl;
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  },
);

export default {
  setToken,
  api: apiCore,
  generic: axios,
};